import * as Styled from './styled'

interface IInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

export const Input = ({
  value,
  onChange,
  placeholder,
  disabled
}: IInputProps) => {
  return (
    <Styled.StyledInput
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
    />
  )
}
